import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { redirectToRegPaymentResumeFlow, redirectToRegResumeFlow } from "./util";
import { RedirectQueryParam, Route } from "../../enums/Redirect";
import { useCopies } from "shared/hooks/useCopies";
import StripeRedirect from "./stripeRedirect";
import { useRegDetail } from "shared/context/regDetail";
import { redirectToExternalURL } from "shared/utils";

export default function HandleRedirects() {
  const navigate = useNavigate();
  const copies = useCopies();
  const [searchParams] = useSearchParams();
  const { marketingUrl } = useRegDetail();

  React.useEffect(() => {
    switch (searchParams.get(RedirectQueryParam.ROUTE)) {
      case Route.REGISTRATION_FORM:
        redirectToRegResumeFlow(navigate, searchParams);
        return;
      case Route.STRIPE_STATUS:
        // intentionally added since StripeSuccessRedirect component will handle everything
        //    if we don't return from here then by default it will go to the home route
        return;
      case Route.REGISTRATION_PAYMENT:
        redirectToRegPaymentResumeFlow(navigate, searchParams);
        return;
      default:
        // if the route param is not present then redirect user to the event's marketing website URL
        redirectToExternalURL(marketingUrl);
    }
  }, [marketingUrl, navigate, searchParams]);

  return (
    <React.Fragment>
      {searchParams.get(RedirectQueryParam.ROUTE) === Route.STRIPE_STATUS ? (
        <StripeRedirect />
      ) : (
        <h1>{copies.get("redirecting")}</h1>
      )}
    </React.Fragment>
  );
}
